// extracted by mini-css-extract-plugin
export default {"btn":"Button_btn__clOzH","large":"Button_large__n4xOd","small":"Button_small__MXnd9"};